/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  QraftServiceOperationsToken,
  RequestFnResponse,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationUseMutationOptions,
} from '@openapi-qraft/tanstack-query-react-types';
import type { Mutation, MutationCache, MutationState, UseMutationResult } from '@tanstack/react-query';

import type { paths } from '../schema';

export interface ServicePlansService {
  /** @summary Create From Template */
  createFromTemplateServicePlansCreateFromTemplatePost: {
    /** @summary Create From Template */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateFromTemplateServicePlansCreateFromTemplatePostBody,
        CreateFromTemplateServicePlansCreateFromTemplatePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateFromTemplateServicePlansCreateFromTemplatePostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateFromTemplateServicePlansCreateFromTemplatePostBody,
          CreateFromTemplateServicePlansCreateFromTemplatePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CreateFromTemplateServicePlansCreateFromTemplatePostData,
          CreateFromTemplateServicePlansCreateFromTemplatePostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CreateFromTemplateServicePlansCreateFromTemplatePostData,
        CreateFromTemplateServicePlansCreateFromTemplatePostError
      >
    >;
    /** @summary Create From Template */
    getMutationKey(
      parameters: DeepReadonly<CreateFromTemplateServicePlansCreateFromTemplatePostParameters> | void
    ): ServiceOperationMutationKey<
      CreateFromTemplateServicePlansCreateFromTemplatePostSchema,
      CreateFromTemplateServicePlansCreateFromTemplatePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create From Template
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlansService.createFromTemplateServicePlansCreateFromTemplatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlansService.createFromTemplateServicePlansCreateFromTemplatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateFromTemplateServicePlansCreateFromTemplatePostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateFromTemplateServicePlansCreateFromTemplatePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateFromTemplateServicePlansCreateFromTemplatePostSchema,
        CreateFromTemplateServicePlansCreateFromTemplatePostData,
        CreateFromTemplateServicePlansCreateFromTemplatePostParameters,
        TVariables,
        OperationError<CreateFromTemplateServicePlansCreateFromTemplatePostError>,
        TContext
      >
    ): UseMutationResult<
      CreateFromTemplateServicePlansCreateFromTemplatePostData,
      OperationError<CreateFromTemplateServicePlansCreateFromTemplatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create From Template
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlansService.createFromTemplateServicePlansCreateFromTemplatePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlansService.createFromTemplateServicePlansCreateFromTemplatePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateFromTemplateServicePlansCreateFromTemplatePostBody,
        CreateFromTemplateServicePlansCreateFromTemplatePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateFromTemplateServicePlansCreateFromTemplatePostSchema,
        CreateFromTemplateServicePlansCreateFromTemplatePostData,
        CreateFromTemplateServicePlansCreateFromTemplatePostParameters,
        TVariables,
        OperationError<CreateFromTemplateServicePlansCreateFromTemplatePostError>,
        TContext
      >
    ): UseMutationResult<
      CreateFromTemplateServicePlansCreateFromTemplatePostData,
      OperationError<CreateFromTemplateServicePlansCreateFromTemplatePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create From Template
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createFromTemplateServicePlansCreateFromTemplatePostTotal = qraft.servicePlansService.createFromTemplateServicePlansCreateFromTemplatePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createFromTemplateServicePlansCreateFromTemplatePostTotal = qraft.servicePlansService.createFromTemplateServicePlansCreateFromTemplatePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateFromTemplateServicePlansCreateFromTemplatePostBody,
            CreateFromTemplateServicePlansCreateFromTemplatePostData,
            CreateFromTemplateServicePlansCreateFromTemplatePostParameters,
            OperationError<CreateFromTemplateServicePlansCreateFromTemplatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateFromTemplateServicePlansCreateFromTemplatePostSchema,
            CreateFromTemplateServicePlansCreateFromTemplatePostBody,
            CreateFromTemplateServicePlansCreateFromTemplatePostData,
            CreateFromTemplateServicePlansCreateFromTemplatePostParameters,
            OperationError<CreateFromTemplateServicePlansCreateFromTemplatePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create From Template
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createFromTemplateServicePlansCreateFromTemplatePostPendingMutationVariables = qraft.servicePlansService.createFromTemplateServicePlansCreateFromTemplatePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createFromTemplateServicePlansCreateFromTemplatePostMutationData = qraft.servicePlansService.createFromTemplateServicePlansCreateFromTemplatePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateFromTemplateServicePlansCreateFromTemplatePostData,
        OperationError<CreateFromTemplateServicePlansCreateFromTemplatePostError>,
        MutationVariables<
          CreateFromTemplateServicePlansCreateFromTemplatePostBody,
          CreateFromTemplateServicePlansCreateFromTemplatePostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateFromTemplateServicePlansCreateFromTemplatePostBody,
            CreateFromTemplateServicePlansCreateFromTemplatePostData,
            CreateFromTemplateServicePlansCreateFromTemplatePostParameters,
            OperationError<CreateFromTemplateServicePlansCreateFromTemplatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateFromTemplateServicePlansCreateFromTemplatePostSchema,
            CreateFromTemplateServicePlansCreateFromTemplatePostBody,
            CreateFromTemplateServicePlansCreateFromTemplatePostData,
            CreateFromTemplateServicePlansCreateFromTemplatePostParameters,
            OperationError<CreateFromTemplateServicePlansCreateFromTemplatePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateFromTemplateServicePlansCreateFromTemplatePostData,
          OperationError<CreateFromTemplateServicePlansCreateFromTemplatePostError>,
          MutationVariables<
            CreateFromTemplateServicePlansCreateFromTemplatePostBody,
            CreateFromTemplateServicePlansCreateFromTemplatePostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create From Template */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateFromTemplateServicePlansCreateFromTemplatePostBody,
            CreateFromTemplateServicePlansCreateFromTemplatePostData,
            CreateFromTemplateServicePlansCreateFromTemplatePostParameters,
            OperationError<CreateFromTemplateServicePlansCreateFromTemplatePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateFromTemplateServicePlansCreateFromTemplatePostSchema,
            CreateFromTemplateServicePlansCreateFromTemplatePostBody,
            CreateFromTemplateServicePlansCreateFromTemplatePostData,
            CreateFromTemplateServicePlansCreateFromTemplatePostParameters,
            OperationError<CreateFromTemplateServicePlansCreateFromTemplatePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create From Template
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.servicePlansService.createFromTemplateServicePlansCreateFromTemplatePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.servicePlansService.createFromTemplateServicePlansCreateFromTemplatePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateFromTemplateServicePlansCreateFromTemplatePostBody,
              CreateFromTemplateServicePlansCreateFromTemplatePostData,
              CreateFromTemplateServicePlansCreateFromTemplatePostParameters,
              OperationError<CreateFromTemplateServicePlansCreateFromTemplatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateFromTemplateServicePlansCreateFromTemplatePostSchema,
              CreateFromTemplateServicePlansCreateFromTemplatePostBody,
              CreateFromTemplateServicePlansCreateFromTemplatePostData,
              CreateFromTemplateServicePlansCreateFromTemplatePostParameters,
              OperationError<CreateFromTemplateServicePlansCreateFromTemplatePostError>,
              TContext
            >
      ):
        | Mutation<
            CreateFromTemplateServicePlansCreateFromTemplatePostData,
            CreateFromTemplateServicePlansCreateFromTemplatePostError,
            MutationVariables<
              CreateFromTemplateServicePlansCreateFromTemplatePostBody,
              CreateFromTemplateServicePlansCreateFromTemplatePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateFromTemplateServicePlansCreateFromTemplatePostBody,
              CreateFromTemplateServicePlansCreateFromTemplatePostData,
              CreateFromTemplateServicePlansCreateFromTemplatePostParameters,
              OperationError<CreateFromTemplateServicePlansCreateFromTemplatePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateFromTemplateServicePlansCreateFromTemplatePostSchema,
              CreateFromTemplateServicePlansCreateFromTemplatePostBody,
              CreateFromTemplateServicePlansCreateFromTemplatePostData,
              CreateFromTemplateServicePlansCreateFromTemplatePostParameters,
              OperationError<CreateFromTemplateServicePlansCreateFromTemplatePostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateFromTemplateServicePlansCreateFromTemplatePostData,
          CreateFromTemplateServicePlansCreateFromTemplatePostError,
          MutationVariables<
            CreateFromTemplateServicePlansCreateFromTemplatePostBody,
            CreateFromTemplateServicePlansCreateFromTemplatePostParameters
          >,
          TContext
        >
      >;
    };
    schema: CreateFromTemplateServicePlansCreateFromTemplatePostSchema;
    types: {
      parameters: CreateFromTemplateServicePlansCreateFromTemplatePostParameters;
      data: CreateFromTemplateServicePlansCreateFromTemplatePostData;
      error: CreateFromTemplateServicePlansCreateFromTemplatePostError;
      body: CreateFromTemplateServicePlansCreateFromTemplatePostBody;
    };
  };
}
/** @summary Create From Template */
export const createFromTemplateServicePlansCreateFromTemplatePost = {
  schema: {
    method: 'post',
    url: '/service_plans/create_from_template',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateFromTemplateServicePlansCreateFromTemplatePostSchema;
  [QraftServiceOperationsToken]: ServicePlansService['createFromTemplateServicePlansCreateFromTemplatePost'];
};
export const servicePlansService = {
  createFromTemplateServicePlansCreateFromTemplatePost,
} as const;
type CreateFromTemplateServicePlansCreateFromTemplatePostSchema = {
  method: 'post';
  url: '/service_plans/create_from_template';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateFromTemplateServicePlansCreateFromTemplatePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateFromTemplateServicePlansCreateFromTemplatePostData =
  paths['/service_plans/create_from_template']['post']['responses']['200']['content']['application/json'];
type CreateFromTemplateServicePlansCreateFromTemplatePostError =
  paths['/service_plans/create_from_template']['post']['responses']['422']['content']['application/json'];
type CreateFromTemplateServicePlansCreateFromTemplatePostBody =
  paths['/service_plans/create_from_template']['post']['requestBody']['content']['application/json'];
